module.exports = __webpack_public_path__ + "media/mobile-header-ru.caca5978.mp4";